import { PERMISSIONS } from "@constants/user.roles";

/** Course Assign permissions — must match login/API identifiers. */
export const STATIC_COURSE_ASSIGN_PERMISSIONS = {
	COURSE_ASSIGN_VIEW: PERMISSIONS.COURSE_ASSIGNMENT_READ,
	COURSE_ASSIGN_LIST: PERMISSIONS.COURSE_ASSIGNMENT_LIST,
	COURSE_ASSIGN_CREATE: PERMISSIONS.COURSE_ASSIGNMENT_CREATE,
	COURSE_ASSIGN_UPDATE: PERMISSIONS.COURSE_ASSIGNMENT_UPDATE,
	COURSE_ASSIGN_DELETE: PERMISSIONS.COURSE_ASSIGNMENT_DELETE,
} as const;

/** Users who assign courses to institutes. */
export const COURSE_ASSIGN_ACCESS_PERMISSIONS = [
	PERMISSIONS.COURSE_ASSIGNMENT_READ,
	PERMISSIONS.COURSE_ASSIGNMENT_LIST,
	PERMISSIONS.COURSE_ASSIGNMENT_CREATE,
	PERMISSIONS.COURSE_ASSIGNMENT_UPDATE,
] as const;

/** Users who can open the Special Initiative courses list and sidebar menu. */
export const SPECIAL_INITIATIVE_ACCESS_PERMISSIONS = [
	PERMISSIONS.COURSE_ASSIGNMENT_SPECIAL_INITIATIVE_READ,
] as const;

export const SPECIAL_INITIATIVE_APPROVE_PERMISSIONS = [
	PERMISSIONS.COURSE_ASSIGNMENT_SPECIAL_INITIATIVE_APPROVE,
] as const;

export const SPECIAL_INITIATIVE_REJECT_PERMISSIONS = [
	PERMISSIONS.COURSE_ASSIGNMENT_SPECIAL_INITIATIVE_REJECT,
] as const;

export type StaticCourseAssignPermission =
	(typeof STATIC_COURSE_ASSIGN_PERMISSIONS)[keyof typeof STATIC_COURSE_ASSIGN_PERMISSIONS];

export const STATIC_COURSE_ASSIGN_PERMISSION_LIST = Object.values(STATIC_COURSE_ASSIGN_PERMISSIONS);
